// ── MD Collection Carousel ──
(function() {
  'use strict';

  document.querySelectorAll('.md-collection-carousel-section').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    var track = document.getElementById('mdCarouselTrack-' + sectionId);
    var dotsContainer = document.getElementById('mdCarouselDots-' + sectionId);
    if (!track) return;

    var slides = track.querySelectorAll('.md-carousel-slide');
    if (!slides.length) return;

    var current = 0;
    var isDragging = false, dragStartX = 0, dragCurrentX = 0;

    // Auto-advance interval from data attribute or default 5s
    var autoAdvanceSec = parseInt(section.dataset.autoAdvance || '5', 10);

    // Build dots
    slides.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'md-carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function() { goTo(i); });
      dotsContainer.appendChild(dot);
    });

    function goTo(n) {
      current = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dotsContainer.querySelectorAll('.md-carousel-dot').forEach(function(d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    // Arrow buttons
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Drag / swipe
    track.addEventListener('mousedown', function(e) { isDragging = true; dragStartX = e.clientX; track.style.transition = 'none'; });
    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      dragCurrentX = e.clientX;
      track.style.transform = 'translateX(calc(-' + (current * 100) + '% + ' + (dragCurrentX - dragStartX) + 'px))';
    });
    window.addEventListener('mouseup', function() {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform .5s cubic-bezier(.4,0,.2,1)';
      var diff = dragCurrentX - dragStartX;
      if (diff < -60) goTo(current + 1);
      else if (diff > 60) goTo(current - 1);
      else goTo(current);
    });

    track.addEventListener('touchstart', function(e) { dragStartX = e.touches[0].clientX; track.style.transition = 'none'; }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      dragCurrentX = e.touches[0].clientX;
      track.style.transform = 'translateX(calc(-' + (current * 100) + '% + ' + (dragCurrentX - dragStartX) + 'px))';
    }, { passive: true });
    track.addEventListener('touchend', function() {
      track.style.transition = 'transform .5s cubic-bezier(.4,0,.2,1)';
      var diff = dragCurrentX - dragStartX;
      if (diff < -60) goTo(current + 1);
      else if (diff > 60) goTo(current - 1);
      else goTo(current);
    });

    // Auto-advance
    if (autoAdvanceSec > 0) {
      setInterval(function() { goTo(current + 1); }, autoAdvanceSec * 1000);
    }
  });
})();
